import { render } from "./Jumbotron.vue?vue&type=template&id=1c74cf9f&scoped=true"
import script from "./Jumbotron.vue?vue&type=script&lang=js"
export * from "./Jumbotron.vue?vue&type=script&lang=js"

import "./Jumbotron.vue?vue&type=style&index=0&id=1c74cf9f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c74cf9f"

export default script